import { OnboardingTooltip } from '@cian/ui-kit';
import * as React from 'react';

import * as styles from './NewbuildingHeaderCompareButton.css';

interface ICompareButtonOnboardingProps extends React.PropsWithChildren {
  open: boolean;
  content: React.ReactNode;
  onClose(): void;
}

export function CompareButtonOnboarding({ children, content, open, onClose }: ICompareButtonOnboardingProps) {
  return (
    <OnboardingTooltip theme="black" content={content} placement="bottom" open={open} onClose={onClose} flip={false}>
      <div className={styles['onboarding-anchor']}>{children}</div>
    </OnboardingTooltip>
  );
}
